// import router from '@/router';
import { getLoginAreaApi } from '@/api/common';
import store from '@/store';
import { SET_AREA_CONFIG, SET_THEME } from '@/store/mutationTypes';
import { parseQuery } from '@/utils';

export const instanceComposable = {
  useApp(app) {
    this.app = app;
  },
  getApp() {
    return this.app;
  },
  useI18n(i18n) {
    this.i18n = i18n;
  },
  getI18n() {
    return this.i18n;
  },
};

// 获取APP用户区域标识
export const getCountryPromise = async () => {
  const resultInject = await window.cfmoto.awaitInject();
  console.log(!resultInject, !window.cfmoto.isNativeEnv, !window.cfmoto.existFunction('getCountry'));
  if (!resultInject || !window.cfmoto.isNativeEnv || !window.cfmoto.existFunction('getCountry')) {
    return Promise.resolve({});
  }
  return new Promise((resolve) => {
    window.cfmoto.getCountry({ success: resolve, fail: () => resolve({}) });
  });
};
// 执行获取APP用户区域标识
export const getCountryComposable = getCountryPromise();

// 获取APP用户区域域名
export const getLoginAreaComposable = getLoginAreaApi();

// 获取区域标识与区域域名
export const getLoginAreaComposablePromise = () => {
  const countryCode = parseQuery(window.location.href).countryCode;
  if (countryCode) {
    return Promise.all([Promise.resolve({ countryCode }), getLoginAreaComposable]);
  }
  return Promise.all([getCountryComposable, getLoginAreaComposable]);
};

// 执行获取区域标识与区域域名
export const getLoginAreaConfigAction = async () => {
  const [resArea, resAreaConfig] = await getLoginAreaComposablePromise();
  const areaNo = resArea.countryCode;
  const items = resAreaConfig.data || [];
  store.commit(SET_AREA_CONFIG, { items, areaNo });
  return { items, areaNo };
};

// 执行获取区域标识与区域域名
export const getLoginAreaConfigActionComposable = getLoginAreaConfigAction();

// 获取区域与用户信息
export const getUserInfoActionPromise = async () => {
  await getLoginAreaConfigActionComposable;
  const userInfo = store.state.user.userInfo || {};
  if (userInfo.userId || userInfo.isUpdate) return userInfo;
  return store.dispatch('fetchUserInfoAction', { meta: { auth: 0 } });
};

export const getUserInfoActionComposable = getUserInfoActionPromise();

const getTheme = () => {
  return new Promise((resolve) => {
    console.log(window.cfmoto);
    window.cfmoto.getSystemTheme({ success: resolve, fail: resolve });
  });
};

export const setTheme = async () => {
  try {
    const isApp = instanceComposable.getApp().isApp;
    console.log(isApp);
    console.log(window.cfmoto);
    if (!isApp) {
      return;
    }
    const status = await getTheme();
    console.log(status);
    if (status && status.errCode == 200) {
      store.commit(SET_THEME, status.theme);
      return;
    } else {
      return;
    }
  } catch (error) {
    return '';
  }
};
